import { modal, dangerBar } from '@/lib/notif'
import debounce from 'lodash/debounce'

export default {
  name: 'SourceSelectBase',
  props: {
    value: { type: [Object, String, Number], default: () => null },
    placeholder: { type: String, default: () => null },
    minChar: { type: Number, default: () => 3 },
    valueField: { type: String, default: () => 'Id' },
    labelField: { type: String, default: () => 'Label' },
    size: { type: String, default: () => null },
  },
  data() {
    return {
      loading: false,
      list: [],
      iModel: null,
      iOption: null,
    }
  },
  computed: {
    autocomplete() {
      return this.$refs.autocomplete
    },
  },
  mounted() {
    setTimeout(() => this.presetup(), 0)
  },
  methods: {
    async presetup() {
      // preload and update select to match
      const { value, valueField } = this
      if (value != null) {
        // try to find it
        await this.fetch({ target: { value: String(value) } }, false)
        const ins = this.list.find(n => n[valueField] === value)
        if (ins) this.selectByValue(ins[valueField])
      }

      this.$emit('ready', this)
    },
    //
    _fetch() {
      return null
    },
    //
    async fetch(event, check = true) {
      const t = this
      const value = !event || !event.target ? '' : event.target.value
      // only check if value available more than min char
      // or empty (loading all)
      const underMinChar =
        value !== null && value.length > 0 && value.length < this.minChar

      if (check && underMinChar) return false

      // search value
      t.loading = true
      return t._fetch(value).then(list => {
        t.loading = false
        t.list = list.recordset
      })
    },

    //
    fetchDebounce: debounce(
      function (...props) {
        return this.fetch(...props)
      },
      200,
      { leading: false, trailing: true },
    ),

    // sync option from autocomplete to model
    syncToModel(option) {
      if (option !== null && typeof option === 'object') {
        // keep version option to easy access
        this.iOption = option
        // tell to outside v-model know the value
        this.$emit('input', option[this.valueField])
        // tell any event listen can get option
        this.$emit('select', option)
      }
      // clear
      else {
        // keep version option to easy access
        this.iOption = null
        // tell to outside v-model know the value
        this.$emit('input', null)
        // tell any event listen can get option
        this.$emit('select', null)
      }
    },

    // manual select option by value key
    async selectByValue(value) {
      const { autocomplete: ac, valueField: vf } = this
      if (ac == null) return null

      // if null then clear
      if (value == null) {
        ac.setSelected(false)
        this.$emit('input', null)
        return true
      }

      // find value in current list
      const ins = this.list.find(n => n[vf] === value)
      if (ins) return ac.setSelected(ins)
      // else must reload list to find one
      await this.fetch({ target: { value: String(value) } }, false)
      const reIns = this.list.find(n => n[vf] === value)
      return ac.setSelected(reIns)
    },

    openModal(Model, width = 450, context, opt) {
      return modal(this, Model, width, context, opt)
    },

    modifyOpt(opt) {
      opt[this.labelField]
    },

    // when forcus, if input value is empty we should allow load
    onFocus() {
      const { iModel } = this
      const check = iModel == null || iModel.length === 0
      // only fetch if list empty. this is avoid multi request hit to server
      // when user tab in - out element
      const listEmpty = this.list.length === 0
      if (check && listEmpty) return this.fetch(null, false)
    },
  },
}
